module.exports = __webpack_public_path__ + "static/media/fastcheckout-success.bd11b180.png";